import CardChartDropDown from '@/components/common/CardChartDropDown';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import Flex from '@/components/common/Flex';
import AvgRankListDrawer from '@/app/KeywordResearch/components/AvgRankListDrawer';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery
} from '@/helpers/utils';
import { useRef, useState } from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
echarts.use([LineChart, TooltipComponent, GridComponent, LegendComponent]);
import _ from 'lodash';
import timeStampToDate from '@/helpers/timeStampToDate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppContext } from '@/Main';
import { useDispatch } from 'react-redux';
import { AiOutlineZoomIn } from 'react-icons/ai';
import { showDrawer } from '@/app/common/reducers/drawer';
import { useTooltipHide } from '@/hooks/useTooltipHide';


const AverageOverallRatingChart = ({ data }) => {
  const chartRef = useRef(null);
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);

  const cardRef = useRef(null);
  const {
    config: { isRTL }
  } = useAppContext();
  const getOption = data => ({
    textStyle: {
      fontFamily: 'dana'
    },
    tooltip: {
      triggerOn: isMdUp ? 'mousemove' : 'click',
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: {
        fontWeight: 500,
        fontSize: 12,
        color: getColor('gray-1100')
      },
      borderWidth: 1,
      formatter: params => {
        let tooltipItem = ``;
        params.forEach(el => {
          tooltipItem =
            tooltipItem +
            `
    <div class="text-700 d-flex flex-row align-items-center justify-content-between w-100 gap-1">
      <span class="text-800 d-flex flex-row-reverse align-items-center gap-1">${el.seriesName}${el.marker}</span>
      <span class="d-flex align-items-center gap-1">
            <span class="fw-bold text-1000">${Math.abs(el?.value * -1)
              ?.toString()
              ?.toPersianDigit()}</span>
      </span>
    </div>`;
        });
        return `
          <div style="width:${isMdUp && '200px'};" class="d-flex flex-column align-items-end">
                <p class='mb-2 text-1000 fw-bold w-100'>
                  ${params[0].axisValue?.toPersianDigit()}
                </p>
                
                ${tooltipItem}
          </div>`;
      },
      transitionDuration: 0,
      color: getColor('gray-100'),
      axisPointer: {
        link: [
          {
            xAxisIndex: [0, 1]
          }
        ]
      }
    },
    xAxis: {
      type: 'category',
      data: data?.update_dates?.map(t => timeStampToDate(Number(t))?.slice(8)),
      boundaryGap: false,
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisTick: { show: false },
      axisLabel: {
        show: false
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      inverse: true,
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-200')
        }
      },
      boundaryGap: false,
      axisLabel: {
        show: true,
        color: getColor('gray-800'),
        margin: 5
      },
      axisTick: { show: false },
      axisLine: { show: false },
      min: _.min(data.average_rank)
    },
    series: [
      {
        name: 'میانگین رتبه',
        type: 'line',
        data: data.average_rank,
        itemStyle: {
          color: getColor('navbar-vertical-default-link-active-color'),
          borderColor: getColor('navbar-vertical-default-link-active-color'),
          borderWidth: 2
        },
        lineStyle: {
          color: getColor('navbar-vertical-default-link-active-color')
        },
        showSymbol: true,
        symbol: 'circle',
        symbolSize: 4,
        smooth: false,
        emphasis: {
          scale: true,
          lineStyle: {
            color: getColor('navbar-vertical-default-link-active-color')
          }
        }
      }
    ],
    grid: { right: '3%', left: '10%', bottom: '10%', top: '5%' }
  });

  const [showAvgRankList, setShowAvgRankList] = useState(false);
  const dispatch = useDispatch();
  return (
    <>
      <AvgRankListDrawer show={showAvgRankList} setShow={setShowAvgRankList} />
      <Card ref={cardRef} className="h-100">
        <FalconCardHeader
          title={
            <div>
              میانگین رتبه کل{' '}
              <FontAwesomeIcon
                icon={['far', 'question-circle']}
                transform="shrink-1"
                style={{
                  transform: isRTL ? 'scaleX(-1)' : 'scaleX(1)',
                  pointerEvents: 'all'
                }}
                className={`ms-1 text-400 cursor-pointer check-list-item`}
                id="weeklySalesTooltip"
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();

                  dispatch(
                    showDrawer({
                      key: 'help',
                      payload: {
                        title: 'میانگین رتبه کل',
                        tooltip: '',
                        manualData: (
                          <div>
                            <h5 className="mb-3">درباره این موضوع</h5>
                            <p className="lh-lg">
                              میانگین رتبه کل یعنی شما در کل کلمات کلیدی که در
                              ابزار کلمات درج کردید چه رتبه ای کسب کردید، این
                              رتبه مربوط به رتبه شما در نتایج گوگل هست، طبیعتا
                              کاهش یا افزایش تعداد کلمات کلیدی اثر مستقیم در
                              میانگین رتبه کل داره. روبه‌روی عدد میانگین رتبه کل
                              هم اختلاف میانگین رتبه کل فعلی با میانگین رتبه کل
                              قبلی هست و میزان رشد و افت در این عدد نمایش میده
                              هر چند نمودار ۷ به‌روزرسانی اخیر رو به شما نمایش
                              هم میده. همچنین شما می‌تونید با زدن آیکون ذره‌بین
                              (داخلش یک مثبت هم داره) میانگین رتبه کل رو در کل
                              طول زمان استفاده از این ابزار مشاهده کنید. زمانی
                              میشه یک تحلیل خوب از این نمودار داشت که حداقل ۷
                              باری کلمات کلیدی خودتون به کمک این ابزار
                              به‌روزرسانی کرده باشید.
                            </p>
                            <h5 className="mb-3">چطور استفاده کنیم؟</h5>
                            <p className="lh-lg">
                              میانگین رتبه کل می‌تونه به شما یک نگاه کلی از روند
                              رتبه‌های شما در نتایج گوگل نمایش بده. نکته مهم:
                              توجه داشته باشید که هر چقدر تعداد کلمات کلیدی
                              بیشتری درج کنید، عدد میانگین رتبه کل واقعی‌تر میشه
                              و درصد خطای این عدد بسیار کم میشه. فرض کنید
                              میانگین سنی همه جوانان در تهران رو قصد دارید حساب
                              کنید، طبیعتا فقط منطقه ۱ تهران رو رصد نمی‌کنید چون
                              آمار فقط یک منقطه رو بررسی کنید عدد میانگین
                              می‌تونه با خطا روبه‌رو بشه و داده‌ها اشتباه در اب
                              در بیاد و طبیعتا تحلیل روی داده‌های اشتباه هم
                              فایده نداره. برای سایت هم همینطور هست، سایتی که
                              صرفا ۱۰ کلمه کلیدی درج کرده میانگین رتبه کل اون
                              درصد خطای بالا داره ولی سایتی که ۲۰۰ کلمه کلیدی
                              درج شده و این کلمات کل فعالیت‌های سایت رو پوشش
                              میده طبیعتا میانگین رتبه کل درصد خطای بسیار کمی
                              داره و یک آنالیز واقعی و خوب میشه از رتبه کل داشت.
                              سعی کنید برای هر آدرسی از سایت شما که براتون مهم
                              هست (دسته مقاله، دسته محصول یا مقاله‌ها یا محصولات
                              و …) حداقل ۵ کلمه کلیدی برای اون آدرس درج کنید تا
                              کنترل بیشتر روی نتایج اون آدرس داشته باشید و در
                              نهایت تحلیل درست‌تر و بهتر رو بتونید پیاده سازی
                              کنید. جامعه آماری در هر جایی بیشتر باشه، تحلیل و
                              نتیجه اون قطعا بهتر میشه و این یک اصل در آمار هست.
                              اگر خواستید خیلی جامع و کامل و به صورت ویدیویی این
                              بخش یاد بگیرید، وارد{' '}
                              <a
                                href="https://help.mizfa.tools/professional-analysis-mizfa-tools/"
                                target="_blank"
                                rel="noreferrer noopener"
                              >
                                این صفحه
                              </a>{' '}
                              بشید و ویدیو ۱ قسمت ۱ نگاه کنید.
                            </p>
                          </div>
                        )
                      }
                    })
                  );
                }}
              />
            </div>
          }
          titleTag="h6"
          className="py-2"
          light
          endEl={
            <>
              <AiOutlineZoomIn
                onClick={() => {
                  setShowAvgRankList(true);
                }}
                icon="search-plus"
                className="cursor-pointer fs-0"
              />
              <CardChartDropDown
                otherDropDowns={
                  <Dropdown.Item
                    onClick={() => {
                      setShowAvgRankList(true);
                    }}
                    className="link-600 fs--1 d-flex align-items-center gap-1 py-1"
                  >
                    نمودار میانگین رتبه
                  </Dropdown.Item>
                }
                cardRef={cardRef}
                chartRef={chartRef}
              />
            </>
          }
        />
        <Card.Body
          as={Flex}
          direction="column"
          justifyContent="between"
          className="py-3"
        >
          <ReactEChartsCore
            ref={chartRef}
            echarts={echarts}
            option={getOption(data)}
            style={{ height: '10rem' }}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default AverageOverallRatingChart;
